import { Engine1Proxy, ConciergeProxy, SagasHelper, RestApiProxy, SagasProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import ProcessManager from '../../../Common/Managers/ProcessManager';
import NovedadesManager from '../../../Common/Managers/NovedadesManager';
import EstadoManager from '../../../Common/Managers/EstadoManager';
import globalHelper from '../../../Common/Helpers/GlobalHelper';
import TransaccionManager from '../../../Common/Managers/TransaccionManager';
import CuentaTarjetaSaldosManager from '../../../Common/Managers/CuentaTarjetaSaldosManager';
import { LOADING } from './SaldosMovimientosActions';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_DATOS_CUENTA_DATA = 'GET_DATOS_CUENTA_DATA';
export const GET_DATA_CUENTA_DATA_RESULT = 'GET_DATA_CUENTA_DATA_RESULT';
export const GET_DATOS_GENERALES_CUENTA = 'GET_DATOS_GENERALES_CUENTA';
export const MODIFICAR_CAMPO_CUENTA = 'MODIFICAR_CAMPO_CUENTA';
export const ROUTE_TO_VISTA_CLIENTE = 'ROUTE_TO_VISTA_CLIENTE';
export const RESET_STATE_DATOS_CUENTA = 'RESET_STATE_DATOS_CUENTA';
export const GET_SALDOS_MOVIMIENTOS = 'GET_SALDOS_MOVIMIENTOS';
export const SELECCIONAR_COMPONENTE = 'SELECCIONAR_COMPONENTE';
export const SET_USER_FUNCTIONS_DATOS_CUENTA = 'SET_USER_FUNCTIONS_DATOS_CUENTA';
export const OPEN_MODAL_DATOS_CUENTA = 'OPEN_MODAL_DATOS_CUENTA';
export const GET_PARAMETRO_GENERAL_CUENTA_CORRIENTE = 'GET_PARAMETRO_GENERAL_CUENTA_CORRIENTE';
export const EDITANDO_CAMPO_CUENTA = 'EDITANDO_CAMPO_CUENTA';
export const MOSTRAR_SPINNER = 'MOSTRAR_SPINNER';
export const CANCEL_NOVEDAD = 'CANCEL_NOVEDAD';
export const SAVE_NOVEDAD = 'SAVE_NOVEDAD';
export const ACEPTA_ADMINISTRADORA = 'ACEPTA_ADMINISTRADORA';
export const RECHAZA_ADMINISTRADORA = 'RECHAZA_ADMINISTRADORA';
export const SELECCIONAR_VALOR_CAMPO = 'SELECCIONAR_VALOR_CAMPO';
export const GET_LOG_MODIFICACIONES_CUENTA = 'GET_LOG_MODIFICACIONES_CUENTA';
export const ACTUALIZAR_ESTADO_NOVEDAD = 'ACTUALIZAR_ESTADO_NOVEDAD';
export const DENIEGA_NOVEDAD = 'DENIEGA_NOVEDAD';
export const LIMPIAR_STORE_COMPONENTE = 'LIMPIAR_STORE_COMPONENTE';
export const RESET_PROP_TARJETAS = 'RESET_PROP_TARJETAS';
export const MODAL_SECCION = 'MODAL_SECCION';
export const EDICION_CAMPO_SECCION = 'EDICION_CAMPO_SECCION';
export const LIMPIAR_PROPIEDADES_MODAL = 'LIMPIAR_PROPIEDADES_MODAL';
export const CHECK_SECCION = 'CHECK_SECCION';
export const VALOR_TEXT_AREA = 'VALOR_TEXT_AREA';
export const GUARDAR_NOVEDAD_PARA_DENEGAR = 'GUARDAR_NOVEDAD_PARA_DENEGAR';
export const MODAL_INFO = 'MODAL_INFO';
export const DATOS_LOG_INTENTOS = 'DATOS_LOG_INTENTOS';
export const GET_DATOS_ACTUALIZADOS = 'GET_DATOS_ACTUALIZADOS';
export const SETEAR_SESION = 'SETEAR_SESION';


let _dispatch;
let _executionContext;
let userFunctions = [];
let userFeatures = [];
let _ultimaNovedad;

/**
 *
 * @param {any} id
 * @param {any} currentScope
 * @param {any} cuenta
 */
export function GetScreenData(currentScope,executionContext) {
    LogHelper.In(GetScreenData.name, currentScope, executionContext);
    const { UserId, ProductCode, CategoryCode, ProgramCode } = currentScope;

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let state = getState();
        _executionContext = executionContext;
        _dispatch = dispatch;

        dispatch({ type: SETEAR_SESION, sesion: _executionContext, currentScope: currentScope });

        var currentScopeRequest = {
            UserId: currentScope.UserId,
            ProductCode: currentScope.ProductCode,
            ProgramCode: currentScope.ProgramCode,
        };
        if (
            (state.tarjetas.darDeBajaCuenta && state.tarjetas.cuentaCorriente.CuentaTarjetaId == state.tarjetas.darDeBajaCuenta) ||
            (state.tarjetas.cuentaCorriente && state.tarjetas.cuentaCorriente.cuentaTarjetaEstadoId == 6)
        ) {
            dispatch({ type: SELECCIONAR_COMPONENTE, componenteId: 4 });
        }
        ConciergeProxy.Execute((data) => _loadUserFunctions(data, state), null, 'GETFUNCTIONS', currentScopeRequest);
    };
}

export function modificarCampoCuenta(campo, valor) {
    LogHelper.In(modificarCampoCuenta.name, campo, valor);

    _dispatch({ type: MODIFICAR_CAMPO_CUENTA, campo, valor });
}

export function limpiarStoreComponente(campo, seccion) {
    LogHelper.In(limpiarStoreComponente.name, campo, seccion);

    return (dispatch, getState) => {
        _dispatch({ type: LIMPIAR_STORE_COMPONENTE, campo, seccion });
    };
}

export function redirectToVistaCliente() {
    LogHelper.In(redirectToVistaCliente.name);

    return (dispatch, getState) => {
        // dispatch({ type: 'REDIRECT_TO_VISTA_CLIENTE', bool: false, cuenta: null });
        // dispatch({ type: REDIRECT_TO_VISTA_CLIENTE });
        _dispatch = dispatch;
        _routing(null, ROUTE_TO_VISTA_CLIENTE, _dispatch);
    };
}

export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch, getState) => {
        dispatch({ type: 'REDIRECT_TO_VISTA_CLIENTE', bool: false, cuenta: null });
        dispatch({ type: RESET_STATE_DATOS_CUENTA });
    };
}

export function resetPropTarjetas(prop) {
    return (dispatch, getState) => {
        dispatch({ type: RESET_PROP_TARJETAS, prop });
    };
}

export function seleccionarComponente(componenteId) {
    LogHelper.In(seleccionarComponente.name, componenteId);

    return (dispatch, getState) => {
        dispatch({ type: SELECCIONAR_COMPONENTE, componenteId });
    };
}

export function openModal(modalId, accion, param, seccion) {
    LogHelper.In(openModal.name, modalId, accion, param, seccion);

    let datosModal;
    let mostrarModalIngresoAjustes = modalId == 4;

    if (accion) {
        return (dispatch, getState) => {
            _dispatch = dispatch;

            let paramModificaciones = {
                NOVEDAD_CODIGO: param.novedadCodigo,
                CUENTA_TARJETA_ID: param.cuentaTarjetaId,
            };

            Engine1Proxy.AddDataSourcesRequests(paramModificaciones, 'GET_LOG_NOVEDAD', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'modificacionesCuenta');
            Engine1Proxy.Execute((data) => _callBackOpenModal(data, seccion), null, null, 'CONSULTASOCIOS');
        };
    } else {
        return (dispatch, getState) => {
            dispatch({ type: OPEN_MODAL_DATOS_CUENTA, modalId, accion, datosModal, seccion, param, mostrarModal: mostrarModalIngresoAjustes });
        };
    }
}
/**
 *
 * @param { string -  "sub store" desde el que se llama a la función (Bajacuentaprepaga, Integrantes, DatosGenerales, etc.)} seccion
 * @param { string - nombre del modal que se abre o cierra} modal
 * @param { bool - true si abre, false si cierra} accion
 * @param { any - parámetros que se quieran guardar al abrir el modal} param
 * @param { string - nombre que va a tener en el store los parametros que le manda} nombreParam
 */
export function modalSeccion(seccion, modal, accion, param, nombreParam) {
    LogHelper.In(modalSeccion.name, seccion, modal, accion, param, nombreParam);

    return (dispatch, getState) => {
        let state = getState();
        state = state.DatosCuenta;
        if (accion) {
            switch (modal) {
                case 'DENUNCIA-TARJETA':
                    //si hay tarjeta pendiente de habilitación el check de reimpresión no se tilda por defecto
                    let hayTarjetaPendienteHabilitacion = false;

                    hayTarjetaPendienteHabilitacion = state.IntegrantesCuenta.integrantes.some(
                        (t) => t.ClienteId == param.ClienteId && t.TarjetaCreditoEstadoId == 3 && !t.FechaHabilitacion && t.FVencimiento < new Date()
                    );

                    if (!hayTarjetaPendienteHabilitacion && !state.IntegrantesCuenta.solicitaReimpresion) {
                        dispatch({ type: CHECK_SECCION, seccion: 'IntegrantesCuenta', prop: 'solicitaReimpresion' });
                    }
                    break;
            }
        }
        dispatch({ type: MODAL_SECCION, accion, seccion, modal, param, nombreParam });
        if (!accion) {
            //SI SE ESTÁ CERRANDO EL MODAL SE LIMPIAN LAS PROPIEDADES QUE SE PUEDAN HABER MODIFICADO POR INPUT DEL MISMO Y LAS VALIDACIONES PERTINENTES
            dispatch({ type: LIMPIAR_PROPIEDADES_MODAL, seccion, modal });
        }
    };
}

//FUNCIÓN PARA LA EDICIÓN DE INPUTS DE CUALQUIER SECCIÓN DE DATOSCUENTA
/**
 *
 * @param { string -  "sub store" desde el que se llama a la función (Bajacuentaprepaga, Integrantes, DatosGenerales, etc.)} seccion
 * @param { string - nombre de la propiedad que se modificará en el store correspondiente} campo
 * @param { string - value del input} valor
 * @param { string - validaciones para agregar al switch y que se corran antes de asignar el valor al input controlado, puede obviarse si no se quiere validar acá} validacion
 */
export function edicionCampoSeccion(seccion, campo, valor, validacion) {
    LogHelper.In(edicionCampoSeccion.name, seccion, campo, valor);
    let valida = true;

    if (validacion) {
        switch (validacion) {
            case 'PIN': {
                let regEx = /^[0-9]{0,4}$/;
                valida = regEx.test(valor);
                break;
            }
            default: {
            }
        }
    }

    return (dispatch, getState) => {
        if (valida) {
            dispatch({ type: EDICION_CAMPO_SECCION, seccion, campo, valor });
        }
    };
}

///////////////////////////// ACTIONS NOVEDADES ////////////////////////////////////////


export function obtenerDatosLogIntentos(IdNovedad){ 
    return (dispatch, getState) => {
        _dispatch({type: DATOS_LOG_INTENTOS, datosLogIntentos:[]})
        let param ={
            'ID_NOVEDAD':IdNovedad
        }
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_LOG_INTENTOS', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, 'GET_LOG_INTENTOS');
        LogHelper.Out(obtenerDatosLogIntentos.name, param, 'GET_LOG_INTENTOS', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, 'GET_LOG_INTENTOS');
        Engine1Proxy.Execute((data) => _callBackobtenerDatosLogIntentos(data), null, null, 'ADMINEMPCUETAR');
    };
}

function _callBackobtenerDatosLogIntentos(data){
    let datosLogIntentos = JSON.parse(data.GET_LOG_INTENTOS).Recordset0.Rows;
    _dispatch({type: DATOS_LOG_INTENTOS, datosLogIntentos});
}

export function editandoCampoCuenta(campo, valor, valorNovedadModificada, seccion, cierra) {
    LogHelper.In(editandoCampoCuenta.name, campo, valor, valorNovedadModificada, seccion, cierra);
    let valorDefaultSelect = valorNovedadModificada ? valorNovedadModificada : valor;
    return (dispatch, getState) => {
        dispatch({ type: EDITANDO_CAMPO_CUENTA, campo, valor: valorDefaultSelect, seccion, cierra });
    };
}

export function guardarNovedad(valorOriginal, seccion, tarjetaId) {
    LogHelper.In(guardarNovedad.name, valorOriginal, seccion, tarjetaId);

    return (dispatch, getState) => {
        let state = getState();
        state = JSON.parse(JSON.stringify(state));

        let puedeGuardar = true;
        let parametroGeneral = state.DatosCuenta.parametroGeneral;
        let entidadTipo;
        let novedadTipo;

        switch (seccion) {
            case 'datosCuentaGenerales':
                entidadTipo = 2;
                novedadTipo = 1;
                break;
            case 'IntegrantesCuenta':
                entidadTipo = 2;
                novedadTipo = 2;
                break;
        }

        const componenteSeleccionado = state.DatosCuenta[seccion].editandoCampo;

        if (puedeGuardar) {
            let novedad = {};
            let novedades = [];
            let novedadesCuentaDatos = [];
            let novedadAnterior = valorOriginal;
            let novedadObtenida,novedadEnviada;
            let CuentaTarjetaId = state.tarjetas.cuentaCorriente.Id;

            switch (seccion) {
                case 'datosCuentaGenerales':
                    novedadesCuentaDatos = state.DatosCuenta.datosCuentaGenerales.novedadesCuentaDatos;
                    break;
                case 'IntegrantesCuenta':
                    novedadesCuentaDatos = state.DatosCuenta.IntegrantesCuenta.novedades;
                    break;
            }


            _dispatch({
                type: MOSTRAR_SPINNER,
            });
            
            novedadEnviada = novedadesCuentaDatos.find((x) => x.NovedadCampoCodigo == "SUCUR_CUEN" && x.NovedadEstadoId == 4);
            
            if(novedadEnviada){
                novedad = {
                    ...novedad,
                    EstadoId: 7,
                    CuentaTarjetaId: CuentaTarjetaId,
                    TipoEntidad: novedadTipo,
                    Id: novedadEnviada ? novedadEnviada.Id : null,
                    Codigo: componenteSeleccionado,
                    ValorAnterior: novedadAnterior,
                    ValorNovedad: state.DatosCuenta[seccion][componenteSeleccionado],
                    UsuarioLogin: _executionContext.login,
                    Terminal: _executionContext.terminalId,
                    tipoEntidad: entidadTipo,
                    UsuarioLoginConf: parametroGeneral && parametroGeneral.SINOCONFIRMACIONMODIFCTA ? null : _executionContext.login,
                    deleteInstance: null,
                    TarjetaCreditoId: tarjetaId ? tarjetaId : null,
                    FechaInterfazAdministradora: new Date(),
                };
    
                novedades.push(novedad);
    
                NovedadesManager.GuardarNovedades(novedades, () => {});
              
            }

            novedadObtenida = novedadesCuentaDatos.find((x) => x.NovedadCampoCodigo == componenteSeleccionado && x.NovedadEstadoId < 3);

            novedad = {
                ...novedad,
                EstadoId: parametroGeneral && parametroGeneral.SINOCONFIRMACIONMODIFCTA ? 1 : 2,
                CuentaTarjetaId: CuentaTarjetaId,
                TipoEntidad: novedadTipo,
                Id: novedadObtenida ? novedadObtenida.Id : null,
                Codigo: componenteSeleccionado,
                ValorAnterior: novedadAnterior,
                ValorNovedad: state.DatosCuenta[seccion][componenteSeleccionado],
                UsuarioLogin: _executionContext.login,
                Terminal: _executionContext.terminalId,
                tipoEntidad: entidadTipo,
                UsuarioLoginConf: parametroGeneral && parametroGeneral.SINOCONFIRMACIONMODIFCTA ? null : _executionContext.login,
                deleteInstance: null,
                TarjetaCreditoId: tarjetaId ? tarjetaId : null,
                FechaInterfazAdministradora: new Date(),
            };

            novedades.push(novedad);

            NovedadesManager.GuardarNovedades(novedades, () => callBackGuardarNovedad(state, novedad, seccion, CuentaTarjetaId));
        } else {
            _dispatch({
                type: CANCEL_NOVEDAD,
                entidadId: entidadTipo,
            });
        }
    };
}

function callBackGuardarNovedad(state, novedad, seccion, CuentaTarjetaId) {
    LogHelper.In(callBackGuardarNovedad.name, state, novedad, seccion);
    let novedadTipo;

    switch (seccion) {
        case 'datosCuentaGenerales':
            novedadTipo = 1;
            break;
        case 'IntegrantesCuenta':
            novedadTipo = 2;
            break;
    }

    const paramsNovedades = { NOVEDAD_TIPO_ID: novedadTipo, ENTIDAD_ID: CuentaTarjetaId, ESTADOS: '1234567' };

    LogHelper.Out(callBackGuardarNovedad.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, 'GET_NOVEDADES_BY_TIPO_AND_ID');
    Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, 'GET_NOVEDADES_BY_TIPO_AND_ID');

    Engine1Proxy.Execute((data) => _loadGetNovedades(data, state, novedad, seccion), null, null, 'ADMINEMPCUETAR');
}

function _loadGetNovedades(data, state, novedad, seccion) {
    LogHelper.In(_loadGetNovedades.name, data, state, novedad, seccion);

    let entidadId = state.DatosCuenta[seccion].entidadTipo;
    let parametroGeneral = state.DatosCuenta.parametroGeneral;

    let novedades = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID).Recordset0.Rows;

    let propNovedades;

    switch (seccion) {
        case 'datosCuentaGenerales':
            propNovedades = 'novedadesCuentaDatos';
            break;
        case 'IntegrantesCuenta':
            propNovedades = 'novedades';
            break;
    }

    ////////ESTO SE HACE PARA ASIGNAR UN ESTADO "ESPECIAL" A ESTAS NOVEDADES PARA QUE SE MUESTREN UNA SOLA VEZ COMO DENEGADAS O RECHAZADAS
    if (state.DatosCuenta[seccion].novedadRechazadaId && state.DatosCuenta[seccion].novedadRechazadaId.length > 0) {
        novedades.map((nov) => {
            if (nov.NovedadEstadoId == 6 && state.DatosCuenta[seccion].novedadRechazadaId.some((rec) => rec == nov.Id)) nov.NovedadEstadoId = 21;
        });
    }

    if (state.DatosCuenta[seccion].novedadDenegadaId && state.DatosCuenta[seccion].novedadDenegadaId.length > 0) {
        novedades.map((nov) => {
            if (nov.NovedadEstadoId == 3 && state.DatosCuenta[seccion].novedadDenegadaId.some((rec) => rec == nov.Id)) nov.NovedadEstadoId = 22;
        });
    }

    novedades.map((nove) => {
        if (nove.NovedadEstadoId > 20) {
            if (novedades.some((n2) => n2.Codigo == nove.Codigo && n2.Id > nove.Id)) nove.NovedadEstadoId = nove.NovedadEstadoId == 21 ? 6 : 3;
        }
    });
    /////////

    _dispatch({
        type: SAVE_NOVEDAD,
        data: novedades,
        entidadId: entidadId,
        seccion,
        propNovedades,
    });

    if (parametroGeneral && !parametroGeneral.SINOCONFIRMACIONMODIFCTA) {
        let novedadActual;
        novedades.map((nov) => {
            if (nov.NovedadCampoCodigo == novedad.Codigo && nov.NovedadEstadoId == 2) novedadActual = nov;
        });

        sendCambioAProcesadora(novedadActual.Id, 2, novedad.Codigo, novedad.TipoEntidad, entidadId, state, novedadActual.ValorAnterior, novedad, seccion);
    }
}

function sendCambioAProcesadora(novedadId, estadoId, novedadCodigo, novedadTipoId, entidadId, state, valorAnterior, ultimaNovedad, seccion) {
    LogHelper.In(sendCambioAProcesadora.name, entidadId, estadoId, valorAnterior);
    var body = '';
    let ultimaNovedadAux = JSON.parse(JSON.stringify(ultimaNovedad));
    if (Array.isArray(ultimaNovedadAux)) ultimaNovedadAux = ultimaNovedadAux[0];

    _dispatch(actualizarNovedadEstado(novedadId, estadoId, novedadCodigo, novedadTipoId, entidadId, seccion));

    switch (novedadCodigo) {
        case 'GRUPA_CUEN':
            body = '{' + '"GrupoAfinidad" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"' + '}';
            break;
        case 'SUCUR_CUEN':
            body = '{' + '"SucursalEmisora" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"' + '}';
            break;
        case 'DENOM_TARJ':
            body = '{' + '"Denominacion" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"' + '}';
            break;
        case 'CRLIN_TARJ':
            body = '{' + '"CuartaLinea" : ' + '"' + ultimaNovedadAux.ValorNovedad.toString() + '"' + '}';
            break;
        default:
            break;
    }
    let paramCuentas = {
        numeroCuenta: state.tarjetas.cuentaCorriente.CuentaEntidadNumero,
        idProducto: state.tarjetas.cuentaCorriente.codigoProducto,
        body: body,
    };

    _dispatch({ type: MOSTRAR_SPINNER });

    Engine1Proxy.AddDataSourcesRequests(paramCuentas, 'MODIFICAR_CUENTA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'clientesObtenidosCuenta');

    let intentos = 0;
    while (intentos < 3) {
        try {
            Engine1Proxy.Execute(
                (data) => _callBacksendCambioAProcesadora(data, novedadId, novedadCodigo, novedadTipoId, entidadId, state, valorAnterior, ultimaNovedad, seccion),
                null,
                null,
                'CONSULTASOCIOS'
            );
            intentos = 3;
        } catch (error) {
            intentos++;
        }
    }
}

export function valorTextArea(txtArea) {
    LogHelper.In(valorTextArea.name, txtArea);

    return (dispatch) => {
        dispatch({ type: VALOR_TEXT_AREA, txtArea: txtArea });
    };
}

export function guardarNovedadParaDenegar(novedadId, estadoId, novedadCodigo, novedadTipoId, seccion, nombreCampo) {
    return (dispatch, getState) => {
        _dispatch = dispatch;
        _dispatch({ type: VALOR_TEXT_AREA, txtArea: 'Ingrese motivo...' });
        _dispatch({ type: GUARDAR_NOVEDAD_PARA_DENEGAR, novedadId, estadoId, novedadCodigo, novedadTipoId, seccion, nombreCampo });
    };
}

export function denegarNovedad() {
    return (dispatch, getState) => {
        _dispatch = dispatch;
        const state = getState();
        const novedadesAux = state.DatosCuenta.datosCuentaGenerales.novedadesCuentaDatos;
        let novedadParaDenegar = state.DatosCuenta.datosCuentaGenerales.novedadParaDenegar;
        let cuentaTarjetaId = state.DatosCuenta.datosCuentaGenerales.CuentaTarjetaId;
        _ultimaNovedad = JSON.parse(JSON.stringify(novedadesAux.filter((n) => n.Id == novedadParaDenegar.Id)));

        let novedad = {};
        let novedades = [];
        let novedadId = novedadParaDenegar.Id;
        let seccion = novedadParaDenegar.seccion;

        novedad.Id = novedadParaDenegar.Id;
        novedad.Codigo = novedadParaDenegar.novedadCodigo;
        novedad.UsuarioLogin = _executionContext.login;
        novedad.Terminal = _executionContext.terminalId;
        let motivo = state.DatosCuenta.datosCuentaGenerales.valorTxtArea;
        novedades.push(novedad);

        dispatch({ type: OPEN_MODAL_DATOS_CUENTA, modalId: 2, undefined, undefined, seccion: false });
        dispatch({ type: MOSTRAR_SPINNER });

        EstadoManager.CambiarEstadoNovedad(
            novedad,
            novedadParaDenegar.estadoId,
            () => {
                getNovedadesByTipoAndId(novedadParaDenegar.novedadTipoId, cuentaTarjetaId, novedadParaDenegar.seccion);
                _dispatch({
                    type: DENIEGA_NOVEDAD,
                    novedadId,
                    seccion,
                });
            },
            motivo
        );
    };
}

export function actualizarNovedadEstado(novedadId, estadoId, novedadCodigo, novedadTipoId, entidadId, seccion, motivo = null) {
    LogHelper.In(actualizarNovedadEstado.name, novedadId, estadoId);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        const state = getState();
        let propNovedades;

        switch (seccion) {
            case 'datosCuentaGenerales':
                propNovedades = 'novedadesCuentaDatos';
                break;
            case 'IntegrantesCuenta':
                propNovedades = 'novedades';
                break;
        }

        const novedadesAux = state.DatosCuenta[seccion][propNovedades];
        let valorAnterior = novedadesAux.map((n) => {
            if (n.Id == novedadId) return n.ValorAnterior;
        })[0];
        let ultimaNovedad = JSON.parse(JSON.stringify(novedadesAux.filter((n) => n.Id == novedadId)));
        let cuentaTarjetaId = state.DatosCuenta.datosCuentaGenerales.CuentaTarjetaId;
        _ultimaNovedad = ultimaNovedad;

        let novedad = {};
        let novedades = [];
        novedad.Id = novedadId;
        novedad.Codigo = novedadCodigo;
        novedad.UsuarioLogin = _executionContext.login;
        novedad.Terminal = _executionContext.terminalId;
        novedades.push(novedad);

        dispatch({ type: MOSTRAR_SPINNER });

        EstadoManager.CambiarEstadoNovedad(
            novedad,
            estadoId,
            () => {
                getNovedadesByTipoAndId(novedadTipoId, cuentaTarjetaId, seccion);
                if (estadoId == 2) {
                    sendCambioAProcesadora(novedadId, 4, novedadCodigo, novedadTipoId, entidadId, state, valorAnterior, ultimaNovedad, seccion);
                } else if (estadoId == 3) {
                    _dispatch({
                        type: DENIEGA_NOVEDAD,
                        novedadId,
                        seccion,
                    });
                }
            },
            motivo
        );
    };
}

function _callBacksendCambioAProcesadora(data, novedadId, novedadCodigo, novedadTipoId, entidadId, state, valorAnterior, ultimaNovedad, seccion) {
    LogHelper.In(_callBacksendCambioAProcesadora.name, entidadId, novedadCodigo);

    var clienteCuentaRespuesta = JSON.parse(data.clientesObtenidosCuenta).Recordset0.Rows[0];

    if (!clienteCuentaRespuesta.IsError) {
        let localValues = mapearCuentaTarjeta(ultimaNovedad);
        const id = state.tarjetas.cuentaCorriente.Id;
        const isQuery = false;
        const deleteInstance = false;
        let campo = '';
        let valor = ultimaNovedad[0] ? ultimaNovedad[0].ValorNovedad : ultimaNovedad.ValorNovedad;
        let integrantesAux;

        switch (
            novedadCodigo //ir agregando los posibles codigos y campos
        ) {
            case 'GRUPA_CUEN':
                campo = 'GrupoAfinidadId';
                break;
            case 'SUCUR_CUEN':
                campo = 'SucursalId';
                break;
            case 'DENOM_TARJ':
                campo = 'DenominacionTarjeta';
                break;
            case 'CRLIN_TARJ':
                campo = 'DenominacionCuartaLinea';
                break;
        }

        switch (novedadTipoId) {
            case 1: {
                Engine1Proxy.AddEventSourcingDataRequest(localValues, 'EVENTSOURCING_TRANSACTION_CUENTA_TARJETA', 'Tarjetas', 'ADMINEMPCUETAR', null, isQuery, null, deleteInstance, id);
                break;
            }
            case 2: {
                integrantesAux = JSON.parse(JSON.stringify(state.DatosCuenta.IntegrantesCuenta.integrantes));
                let novAux2 = ultimaNovedad[0] ? ultimaNovedad[0] : ultimaNovedad;
                integrantesAux.map((int) => {
                    if (int.ClienteId == novAux2.ClienteId) int[campo] = novAux2.ValorNovedad;
                });

                Engine1Proxy.AddEventSourcingDataRequest(localValues, 'EVENTSOURCING_TRANSACTION_TARJETA_CREDITO', 'Tarjetas', 'ADMINEMPCUETAR', null, isQuery, null, deleteInstance, id);
                break;
            }
        }

        Engine1Proxy.Execute((data) => {}, null, null, 'ADMINEMPCUETAR');
        /**
         * ADT-1362
         * Migrada de jira gyf: http://jira.gyf.com/browse/UAAD17-1092
         * Se deberá modificar el alcance de la tarea UAAD17-248 en su punto 3, pero únicamente si el atributo de la cuenta modificado fue la sucursal,
         * según se indica en verde a continuación:
         * Si fue exitosa, no realizar ninguna acción.
         * Actualizar sólo si la respuesta del procesador no fue exitosa, es decir,
         * si el campo anterior se actualizó a estado 6 - Rechazada por la Administradora.
         * Si la respuesta fue exitosa, indicar al usuario mediante mensaje "La actualización de la sucursal se informó de manera satisfactoria al procesador.
         * La misma tomará efecto con el cierre de cartera/mes.
         */
        if (novedadCodigo != 'SUCUR_CUEN') _dispatch(actualizarNovedadEstado(novedadId, 5, novedadCodigo, novedadTipoId, entidadId, seccion));
        else
            _dispatch({
                type: MODAL_INFO,
                titulo: 'Atención',
                mensaje: 'La actualización de la sucursal se informó de manera satisfactoria al procesador. La misma tomará efecto con el cierre de cartera/mes.',
                mostrar: true,
            });

        switch (novedadTipoId) {
            case 1: {
                _dispatch({
                    type: ACEPTA_ADMINISTRADORA,
                    campo,
                    valor,
                    seccion,
                    novedadId,
                });
                break;
            }
            case 2: {
                _dispatch({
                    type: ACEPTA_ADMINISTRADORA,
                    campo: 'integrantes',
                    valor: integrantesAux,
                    seccion,
                    novedadId,
                });
                break;
            }
        }
    } else {
        LogHelper.In(globalHelper.formateoMensajeError(clienteCuentaRespuesta.ErrorObject.Description), entidadId, novedadCodigo);

        _dispatch(actualizarNovedadEstado(novedadId, 6, novedadCodigo, novedadTipoId, entidadId, seccion, clienteCuentaRespuesta.ErrorObject.Description));
        let campo = '';
        let valor = valorAnterior;

        switch (novedadCodigo) {
            case 'GRUPA_CUEN':
                campo = 'GrupoAfinidadId';
                break;

            case 'SUCUR_CUEN':
                campo = 'SucursalId';
                break;

            case 'DENOM_TARJ':
                campo = 'DenominacionTarjeta';
                break;

            case 'CRLIN_TARJ':
                campo = 'CuartaLinea';
                break;
        }

        _dispatch({
            type: RECHAZA_ADMINISTRADORA,
            novedadId,
            seccion,
        });
    }
}

function mapearCuentaTarjeta(ultimaNovedad) {
    let now = new Date();
    let values;
    let novAux = ultimaNovedad;
    if (Array.isArray(ultimaNovedad)) novAux = ultimaNovedad[0];

    switch (novAux.Codigo) {
        case 'GRUPA_CUEN':
            values = {
                GRUPO_AFINIDAD_ID: novAux.ValorNovedad,
            };
            break;
        case 'SUCUR_CUEN':
            values = {
                SUCURSAL_ID: novAux.ValorNovedad,
            };
            break;
        case 'DENOM_TARJ':
            values = {
                DENOMINACION: novAux.ValorNovedad,
            };
            break;
        case 'CRLIN_TARJ':
            values = {
                CUARTA_LINEA: novAux.ValorNovedad,
            };
            break;
        default:
            break;
    }
    return values;
}

export function selectValorCampo(codigo, valor, seccion) {
    LogHelper.In(selectValorCampo.name, codigo, valor, seccion);

    let valorAux = valor;

    switch (codigo) {
        case 'DENOM_TARJ': {
            let regEx = /^[a-zA-ZñÑáÁéÉíÍóÓúÚ.\s]{1,26}$/;
            if (!regEx.test(valor) && valor != '') {
                valorAux = null;
            }
            break;
        }
        case 'CRLIN_TARJ': {
            let regEx = /^[a-zA-Z0-9ñÑáÁéÉíÍóÓúÚ.\s]{1,26}$/;

            if (!regEx.test(valor) && valor != '') {
                valorAux = null;
            }
            break;
        }
    }
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: SELECCIONAR_VALOR_CAMPO,
            codigo,
            valor: valorAux,
            seccion,
        });
    };
}

export function getLogModificaciones(novedadCodigo, cuentaTarjetaId, seccion) {
    LogHelper.In(getLogModificaciones.name, novedadCodigo, cuentaTarjetaId, seccion);

    return (dispatch, getState) => {
        if (novedadCodigo) {
            let state = getState();
            let cTId = state.tarjetas.cuentaCorriente.CuentaTarjetaId;

            _dispatch = dispatch;
            let paramModificaciones = {
                NOVEDAD_CODIGO: novedadCodigo,
                CUENTA_TARJETA_ID: cuentaTarjetaId ? cuentaTarjetaId : cTId,
            };

            Engine1Proxy.AddDataSourcesRequests(paramModificaciones, 'GET_LOG_NOVEDAD', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'modificacionesCuenta');
            Engine1Proxy.Execute((data) => _callBackGetLogModificaciones(data, novedadCodigo, seccion), null, null, 'CONSULTASOCIOS');
        } else {
            dispatch({ type: GET_LOG_MODIFICACIONES_CUENTA, modificaciones: null, campoCodigo: null, seccion });
        }
    };
}

function _callBackGetLogModificaciones(data, novedadCodigo, seccion) {
    let modificaciones = JSON.parse(data.modificacionesCuenta).Recordset0.Rows;
    globalHelper.OrdenarArrayPorFecha(modificaciones, 'FechaHoraModificacion');

    _dispatch({ type: GET_LOG_MODIFICACIONES_CUENTA, modificaciones, campoCodigo: novedadCodigo, seccion });
}

function getNovedadesByTipoAndId(novedadTipoId, entidadId, seccion) {
    LogHelper.In(getNovedadesByTipoAndId.name);

    const paramsNovedades = { NOVEDAD_TIPO_ID: novedadTipoId, ENTIDAD_ID: entidadId, ESTADOS: '1234567' };
    LogHelper.Out(getNovedadesByTipoAndId.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, 'GET_NOVEDADES_BY_TIPO_AND_ID_0');
    Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, 'GET_NOVEDADES_BY_TIPO_AND_ID_0');

    /*si novedadTipoId es 2, quiere decir que son tarjetas entonces se debe consultar ambas novedades, las canceladas y las normales*/
    if (novedadTipoId == 2) {
        const paramsNovedadesCancelada = { NOVEDAD_TIPO_ID: novedadTipoId, ENTIDAD_ID: entidadId, ESTADOS: '7' };

        /*novedades, canceladas*/
        LogHelper.Out(
            getNovedadesByTipoAndId.name,
            paramsNovedadesCancelada,
            'GET_NOVEDADES_BY_TIPO_AND_ID',
            'Get',
            'Tarjetas',
            'ADMINEMPCUETAR',
            1,
            'Product',
            true,
            'GET_NOVEDADES_BY_TIPO_AND_ID_1'
        );
        Engine1Proxy.AddDataSourcesRequests(paramsNovedadesCancelada, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, 'GET_NOVEDADES_BY_TIPO_AND_ID_1');
    }

    Engine1Proxy.Execute((data) => callbackNovedadesByTipoAndId(data, novedadTipoId, seccion), null, 'ADMINEMPCUETAR');
}

function callbackNovedadesByTipoAndId(data, novedadTipoId, seccion) {
    let novedades = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_0).Recordset0.Rows;
    let novedadesCanceladas = [];

    /*Si existe el _1 quiere decir que hay novedades canceladas de tarjetas*/
    if (data.GET_NOVEDADES_BY_TIPO_AND_ID_1) {
        novedadesCanceladas = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_1).Recordset0.Rows;
    }

    _dispatch({ type: ACTUALIZAR_ESTADO_NOVEDAD, novedades, novedadTipoId, novedadesCanceladas, seccion });
}

//////////////////////////// FIN ACTIONS NOVEDADES /////////////////////////////////////

/* -------------------------------------------- FUNCIONES AUXILIARES -------------------------------------------- */
function _loadUserFunctions(data, state) {
    LogHelper.In(_loadUserFunctions.name, data);

    let functions = data.CONSULTASOCIOS;
    let functionsAllowed = {};

    functions.forEach((p) => {
        functionsAllowed[p.Codigo_Funcion] = true;
    });

    //Se agrega validación de permisos para pantalla de Ingreso/Cargos Individuales. #ADT-1983
    functions = data.CARGAAJUSTES;
    let ajustesFunctionsAllowed = {};

    if (functions) {
        functions.forEach((p) => {
            ajustesFunctionsAllowed[p.Codigo_Funcion] = true;
        });
    } else {
        ajustesFunctionsAllowed = undefined;
    }

    //Se re-ajusta validación de permisos para pantalla de Integrantes
    let funciones = data.ADMINEMPCUETAR;
    let funciontesIntegrantesPermitidas = {};

    funciones.forEach((p) => {
        funciontesIntegrantesPermitidas[p.Codigo_Funcion] = true;
    });

    _dispatch({ type: SET_USER_FUNCTIONS_DATOS_CUENTA, functions: functionsAllowed, ajustesFunctions: ajustesFunctionsAllowed, integrantesFunciones: funciontesIntegrantesPermitidas });

    getTransaccionDiariaData(state);
}

function getTransaccionDiariaData(state) {
    let fecha = new Date();
    let mesActual = fecha.getMonth() + 1; 
    //Se agrega un "0" delante del día en el caso de que sea un día de un solo dígito y evitar que falle la llamada al servicio de Ualá. #ADT-1596
    let today = fecha.getFullYear() + '-' + (mesActual > 9 ? mesActual : '0' + mesActual) + '-' + (fecha.getDate() > 9 ? fecha.getDate() : '0' + fecha.getDate()); //*/"2020-07-01";
    let tomorrow = fecha.getFullYear() + '-' + (mesActual > 9 ? mesActual : '0' + mesActual) + '-' + ((fecha.getDate() + 1) > 9 ? (fecha.getDate() + 1) : '0' + (fecha.getDate() + 1)); //*/"2020-07-31";


    _dispatch({ type: LOADING, valor: true });

    let param = {
        numeroCuenta: state.tarjetas.cuentaCorriente.CuentaEntidadNumero, //"f336b5b1-b734-4f13-94ed-f1844cd416af",
        idProducto: state.tarjetas.cuentaCorriente.codigoProducto,
        fechaDesde: today,
        fechaHasta: tomorrow,
    };
    //INVOCO AL MÉTODO DE TRANSACCION DIARIA
    //Engine1Proxy.AddDataSourcesRequests(param, 'OBTENER_MOVIMIENTOS_DIARIOS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, null);
    //Engine1Proxy.Execute((data) => _callBackGetMovimientosDiarios(data, state), null, null, 'CONSULTASOCIOS');

    _callBackGetMovimientosDiarios(null, state);
}

function _callBackGetMovimientosDiarios(data, state) {
    _callBackGetTransaccionesBD(state);

    //var movimientos = JSON.parse(data.OBTENER_MOVIMIENTOS_DIARIOS).Recordset0.Rows[0];
//
    //if (!movimientos.IsError) {
    //    var movimientosParse = movimientos.Result.replaceAll("'", '"');
    //    let transacciones = movimientosParse && movimientosParse != '' ? JSON.parse(movimientosParse) : undefined;
//
    //    if (transacciones && transacciones.Resultado && transacciones.Resultado.length > 0) {
    //        let param = {
    //            transacciones: transacciones.Resultado,
    //            cuentaTarjetaId: state.tarjetas.cuentaCorriente.CuentaTarjetaId,
    //        };
//
    //        TransaccionManager.GuardarTransaccion(param, SagasHelper.GetSagasId, () => _callBackGetTransaccionesBD(state));
    //    } else {
    //        _callBackGetTransaccionesBD(state);
    //    }
    //} else {
    //    _callBackGetTransaccionesBD(state);
    //}
}

function _callBackGetTransaccionesBD(state) {
    let periodo = new Date();
    let mesActual = periodo.getMonth() + 1; 

    periodo = (mesActual > 9 ? mesActual : '0' + mesActual) + '/' + periodo.getFullYear();

    /* let paramCuentas = {
        numeroCuenta: state.tarjetas.cuentaCorriente.CuentaEntidadNumero,
        idProducto: state.tarjetas.cuentaCorriente.codigoProducto,
    }; */
    let localValue = {
        ADMINISTRADORA_ID: state.tarjetas.cuentaCorriente.marcaId,
    };

    //#ADT-1659 - se arma los parametros para la adecuación del SP up_MovimientosXCuenta
    let paramCuentaTarjeta = {
        ID_CUENTATARJETA: state.tarjetas.cuentaCorriente.CuentaTarjetaId,
        PERIODO: periodo,
        TIPO_SALDO: 'P' 
    };

    let paramMovimientosSinConf = {
        ID_CUENTATARJETA: state.tarjetas.cuentaCorriente.CuentaTarjetaId
    };

    let paramGetSaldoAdintar = {
        CUENTA_TARJETA_ID: state.tarjetas.cuentaCorriente.CuentaTarjetaId
    };

    try {
        Engine1Proxy.AddDataSourcesRequests(paramCuentaTarjeta, 'SP_GET_SALDOS_MOVIMIENTOS', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true, 'ObtenerMovimientosAdintar');
        Engine1Proxy.AddDataSourcesRequests(paramMovimientosSinConf, 'SP_GET_SALDOS_MOVIMIENTOS_SIN_CONFIRMAR', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true, 'MovimientosSinConfirmar');
        //Engine1Proxy.AddDataSourcesRequests(paramCuentas, 'GET_DATOS_CUENTA_DATA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'clientesObtenidosCuenta');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PARAMETRO_GENERAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramGetSaldoAdintar, 'UP_GET_SALDOACTUAL', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'saldoAdintar');
        //Engine1Proxy.AddDataSourcesRequests(null, 'GET_DATOS_ACTUALIZADOS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'datosActualizados');
    
    
        Engine1Proxy.Execute((data) => _callBackGetScreenData(data, state), null, null, 'CONSULTASOCIOS');       
    } catch (error) {
        _callbackGuardarSaldoObtenidodeGP(state, false, state.tarjetas.cuentaCorriente.CuentaTarjetaId);
    }
}

export function getMayorId(a, b) {
    const idA = a.id ? a.id : a.ID;
    const idB = b.id ? b.id : b.ID;

    let IDMayor = 0;
    if (idA > idB) {
        IDMayor = -1;
    } else if (idA < idB) {
        IDMayor = 1;
    }
    return IDMayor;
}

function _callBackGetScreenData(data, state) {
    //var clienteCuentaRespuesta = JSON.parse(data.clientesObtenidosCuenta).Recordset0.Rows[0];
    var parametroGeneral = JSON.parse(data.GET_PARAMETRO_GENERAL).Recordset0.Rows[0];
    var CuentaTarjetaId = state.tarjetas.cuentaCorriente.CuentaTarjetaId;
    //let datosActualizados = JSON.parse(data.datosActualizados).Recordset0.Rows[0];

    var SaldosMov = {
        Saldos: JSON.parse(data.ObtenerMovimientosAdintar).Recordset0.Rows,
        SaldoAdintar17: JSON.parse(data.saldoAdintar).Recordset0.Rows,
        MovimientosSinConfirmar:{
            totalAutorizaciones: JSON.parse(data.MovimientosSinConfirmar).Recordset0.Rows[0].TotalAutorizaciones,
            totalAjustesCargos: JSON.parse(data.MovimientosSinConfirmar).Recordset1.Rows[0].TotalAjustesCargos,
            movimientosSinConfirmar: JSON.parse(data.MovimientosSinConfirmar).Recordset2.Rows,            
        }        
    };

    SaldosMov.Saldos.sort(getMayorId);

    _dispatch({ type: GET_SALDOS_MOVIMIENTOS, SaldosMov });
    _dispatch({ type: GET_PARAMETRO_GENERAL_CUENTA_CORRIENTE, parametroGeneral });
    //_dispatch({ type: GET_DATOS_ACTUALIZADOS, data: datosActualizados });
    _dispatch({ type: LOADING, valor: false });

    _callbackGuardarSaldoObtenidodeGP(state, null, CuentaTarjetaId);

    //if (!clienteCuentaRespuesta.IsError) {
    //    var clienteCuentaRespuestaParse = clienteCuentaRespuesta.Result.replaceAll("'", '"');
    //    var saldoGlobal = clienteCuentaRespuestaParse == '' ? [] : JSON.parse(clienteCuentaRespuestaParse);
    //    saldoGlobal = _cambiarSigno(saldoGlobal);
    //    saldoGlobal = _cambiarDatosSegunFuente(saldoGlobal);
//
    //    _dispatch({ type: GET_DATOS_CUENTA_DATA, saldoGlobal });
//
    //    // let localValues = mapearCuentaTarjetaSaldo(saldoGlobal, CuentaTarjetaId);
//
    //    // const isQuery = false;
    //    // const deleteInstance = false;
//
    //    // Engine1Proxy.AddEventSourcingDataRequest(localValues.saldo
    //    //     , 'EVENTSOURCING_TRANSACTION_CUENTA_TARJETA_SALDO'
    //    //     , 'Tarjetas'
    //    //     , 'ADMINEMPCUETAR'
    //    //     , null
    //    //     , isQuery
    //    //     , null
    //    //     , deleteInstance
    //    //     , null);
//
    //    //ADT-1528 - Se comenta el llamado a la saga que guarda en BD los saldos obtenidos por GP
    //    //CuentaTarjetaSaldosManager.CrearCuentaTarjetaSaldo(saldoGlobal, CuentaTarjetaId, SagasHelper.GetSagasId, () => _callbackGuardarSaldoObtenidodeGP(state, saldoGlobal, CuentaTarjetaId));
    //    _callbackGuardarSaldoObtenidodeGP(state, saldoGlobal, CuentaTarjetaId);
//
    //    //Engine1Proxy.Execute((data) => _callbackGuardarSaldoObtenidodeGP(state, saldoGlobal, CuentaTarjetaId), null, null, "ADMINEMPCUETAR");
    //    
    //} else {
    //    let descripcionError = clienteCuentaRespuesta.ErrorObject ? clienteCuentaRespuesta.ErrorObject.Description : "";
    //    LogHelper.In(globalHelper.formateoMensajeError(descripcionError), data);
    //    _callbackGuardarSaldoObtenidodeGP(state, false, CuentaTarjetaId);
    //}
}

function _cambiarSigno(saldoGlobal) {
    var saldoModificado = saldoGlobal;
    saldoModificado.SaldoPesos = saldoModificado.SaldoPesos == undefined ? null : saldoModificado.SaldoPesos * -1;
    return saldoModificado;
}

function _cambiarDatosSegunFuente(saldoGlobal) {
    var datosModificados = saldoGlobal;
    if (saldoGlobal.DesdeBD) {
        datosModificados.SaldoPesos = null;
    }
    return datosModificados;
}

/**
 *
 * @param {any} cuentaTarjetaSaldo
 */
function mapearCuentaTarjetaSaldo(SaldoPesos, CuentaTarjetaId) {
    //TODO: Esta fecha tiene que se obtenida del servidor. No del navegador del usuario.
    let now = new Date();
    let values = {
        saldo: {
            FECHA_CIERRE: now,
            FECHA_VENCIMIENTO: null,
            PAGO_MINIMO: null,
            SALDO_CIERRE_PESOS: SaldoPesos,
            SALDO_CIERRE_DOLARES: 0,
            CUENTA_TARJETA_ID: CuentaTarjetaId,
            CARTERA_ID: null,
            FORMA_PAGO_ID: null,
            CUENTA_BANCARIA_ID: null,
            ESTADO_CUENTA_ID: null,
            FORMA_DEBITO_ID: null,
        },
    };

    return values;
}

function _callbackGuardarSaldoObtenidodeGP(state, saldoGlobal, CuentaTarjetaId) {
    let paramCuenta = {
        CUENTA_TARJETA_ID: state.tarjetas.cuentaCorriente.CuentaTarjetaId,
    };

    const paramsNovedades = { NOVEDAD_TIPO_ID: 1, ENTIDAD_ID: state.tarjetas.cuentaCorriente.CuentaTarjetaId, ESTADOS: '1234567' };

    Engine1Proxy.AddDataSourcesRequests(null, 'GET_SUCURSALES_ACTIVAS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramCuenta, 'GET_GAF_ACTIVO_BY_CUENTA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramCuenta, 'GET_DATOS_MODIFICACION_CUENTA_BY_CUENTAID', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true);
    LogHelper.Out(_callbackGuardarSaldoObtenidodeGP.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, 'GET_NOVEDADES_BY_TIPO_AND_ID');
    Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, 'GET_NOVEDADES_BY_TIPO_AND_ID');

    Engine1Proxy.Execute(
        (data) => {
            _loadScreenData(data, state, saldoGlobal);
        },
        null,
        null,
        'PARAMETRIA'
    );
}

/**
 *
 * @param {any} data
 */
function _loadScreenData(data, state, saldoGlobal) {
    LogHelper.In(_loadScreenData.name, data, saldoGlobal);
    const executionContext =_executionContext;

    data = {
        ...data,
        SucursalesCuenta: JSON.parse(data.GET_SUCURSALES_ACTIVAS).Recordset0.Rows,
        GruposAfinidadCuenta: JSON.parse(data.GET_GAF_ACTIVO_BY_CUENTA).Recordset0.Rows,
        SucursalDescripcion: state.tarjetas.cuentaCorriente.sucursalDescripcion,
        GrupoAfinidadId: JSON.parse(data.GET_DATOS_MODIFICACION_CUENTA_BY_CUENTAID).Recordset0.Rows[0].GrupoAfinidad,
        SucursalId: JSON.parse(data.GET_DATOS_MODIFICACION_CUENTA_BY_CUENTAID).Recordset0.Rows[0].Sucursal,
        CuentaTarjetaId: state.tarjetas.cuentaCorriente.CuentaTarjetaId,
        CuentaCorriente: state.tarjetas.cuentaCorriente,
        cuentaTarjetaEstadoId: state.tarjetas.cuentaCorriente.cuentaTarjetaEstadoId,
        novedadesCuentaDatos: JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID).Recordset0.Rows,
        saldoGlobal: saldoGlobal,
        executionContext,
    };

    data.novedadesCuentaDatos.map((nov) => {
        if ([1, 4].some((e) => e == nov.NovedadEstadoId) && nov.NovedadCampoCodigo == 'GRUPA_CUEN') data.GrupoAfinidadId = nov.ValorNovedad;
        else if ([1, 4].some((e) => e == nov.NovedadEstadoId) && nov.NovedadCampoCodigo == 'SUCUR_CUEN') data.SucursalId = nov.ValorNovedad;
    });

    _dispatch({ type: GET_DATOS_GENERALES_CUENTA, data: data /*cuenta: _cuenta*/ });
    if (saldoGlobal == false) {
        _dispatch({ type: LOADING, valor: false });
    }
}

/**
 * Funcion encargada del ruteo.
 * @param {any} params
 * @param {any} option
 * @param {any} dispatch
 */
function _routing(params, option, dispatch) {
    LogHelper.In(_routing.name, params, option, dispatch);

    if (params) {
        params = JSON.stringify(params);
    }

    const redirectLocation = ProcessManager.GetNextStep('DatosCuenta', option, params);

    dispatch({ type: ROUTE_TO_VISTA_CLIENTE, data: redirectLocation });
}

/**
 * función que abre el modal de modificaciones de la cuenta y carga los datos correspondientes
 *
 */

function _callBackOpenModal(data, seccion) {
    var modificacionesCuenta = JSON.parse(data.modificacionesCuenta).Recordset0.Rows;
    let ultimaModificacionCompletada = '';

    modificacionesCuenta.map((mod) => {
        if (mod.NovedadEstadoId == 1) ultimaModificacionCompletada = mod.FechaHoraModificacion;
    });

    modificacionesCuenta = modificacionesCuenta.filter((m) => (m.NovedadEstadoId == 1 && m.FechaHoraModificacion == ultimaModificacionCompletada) || m.NovedadEstadoId != 1);

    _dispatch({ type: OPEN_MODAL_DATOS_CUENTA, modalId: 1, accion: true, datosModal: modificacionesCuenta, seccion });
}
export function ocultarModalInfo() {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_INFO,
            titulo: '',
            mensaje: '',
            mostrar: false,
        });
    };
}


export function ocultarModalDatosCuentaIngresoAjustes() {
    return (dispatch, getState) => {
        dispatch({ type: OPEN_MODAL_DATOS_CUENTA, modalId: 4, mostrarModal: false })
    };
}